if (!customElements.get('faqs-component')) {
  customElements.define(
    'faqs-component',
    class FaqsComponent extends HTMLElement {
      constructor() {
        super();
        document.addEventListener('DOMContentLoaded', () => {
            this.initAccordeon();
        });
      }  
         
      initAccordeon(){
        const accordeons = this.querySelectorAll(".faq__item");
        accordeons.forEach((accordeon) =>{
            accordeon.addEventListener("click",()=>{
                if(accordeon.classList.contains("faq__item--open")){
                  accordeon.classList.remove("faq__item--open");
                }else{
                  accordeons.forEach((a)=>{a.classList.remove("faq__item--open")});
                  accordeon.classList.add("faq__item--open");
                }
            })
        })
      }
    }
  );
}
